import { Button, Card } from '@iwoca/orion';

import { useGetANTFormalOffers } from '../../hooks/useGetANTFormalOffers';
import { formatCurrency } from '../../utils/currency';
import { formatDate as formatDateUtil } from '../../utils/date';

const formatDate = (
  dateString: string | null = '',
  format: 'short' | 'long' = 'short',
) => {
  const date = dateString || new Date().toISOString();
  return formatDateUtil(date, format, { yearFormat: '2-digit' });
};

const getSoonestTimeout = (
  offers: { timeout?: string | null }[],
): string | null | undefined => {
  const offerWithSoonestTimeout = offers.reduce((prev, curr) =>
    (prev.timeout ?? '') < (curr.timeout ?? '') ? prev : curr,
  );
  return offerWithSoonestTimeout.timeout;
};

export const ANTCard = () => {
  const { antFormalOffers, loadingANTFormalOffers } = useGetANTFormalOffers();

  if (loadingANTFormalOffers) return null;
  if (!antFormalOffers || antFormalOffers.length === 0) return null;

  if (antFormalOffers.length === 1) {
    const [offer] = antFormalOffers;
    const dateString = formatDate(offer.timeout, 'long');

    return (
      <Card className="mb-xl overflow-hidden bg-primary-20 text-structure-100">
        <div className="flex w-full items-center gap-l p-l">
          <div>
            <div className="mb-xs text-xs font-reg">
              Offer valid until {dateString}
            </div>
            <div className="mb-s text-l font-bold">
              You're <b>approved</b> for a{' '}
              <b>{formatCurrency(offer.available_cash!, 0)}</b> loan from iwoca.
            </div>
            <div className="mb-l text-s font-reg">
              Hit the button to access these funds today.
            </div>
            <a href="/my-offers/">
              <Button variant="secondary">Access funds</Button>
            </a>
          </div>
        </div>
      </Card>
    );
  }

  if (antFormalOffers.length > 1) {
    const timeout = getSoonestTimeout(antFormalOffers);
    const dateString = formatDate(timeout, 'long');

    return (
      <Card className="mb-xl overflow-hidden bg-primary-20 text-structure-100">
        <div className="flex w-full items-center gap-l p-l">
          <div>
            <div className="mb-xs text-xs font-reg">
              First offer valid until {dateString}
            </div>
            <div className="mb-s text-l font-bold">
              You've been <b>approved</b> for more than one loan with iwoca.
            </div>
            <div className="mb-l text-s font-reg">
              Hit the button to see your offers and choose the one that works
              best for you.
            </div>
            <a href="/my-offers/">
              <Button variant="secondary">See your offers</Button>
            </a>
          </div>
        </div>
      </Card>
    );
  }

  return null;
};
